// import request from '@/assets/js/request'
// import getQueryString from '@/assets/js/url'
// import Fingerprint from 'fingerprintjs'
// import store from '@/store'

const monitor = (data) => {
  // // data参数（PC没有活动，只传pageId就可以） => {
  // //   currencyId: 0, // 活动的id
  // //   currencyName: "", // 活动名称（详情需要传该字段，传的内容是商品名称）
  // //   pageId: 0, // 页面id
  // //   pageTypeId: 0, // 页面类型id,例如:砍价:1/拼团:2/秒杀:3之类的
  // // }
  // let isRequst = sessionStorage.getItem('isRequst')
  // if (!isRequst) {
  //   return false
  // }
  // let source = getQueryString('utmSource') || null // 来源
  // let fingerprint = new Fingerprint().get()
  // let usersDataSave = {
  //   ...data,
  //   source, // 来源
  //   channelDetailsId: 4, // 飞利浦PC端渠道详情id
  //   channelId: 1, // 渠道id,小程序1,h5:2,pc:3
  //   userId: store.getters.info.id ? store.getters.info.id : fingerprint // 用户唯一id
  // }
  // if (!usersDataSave.userId) return
  // request('/gateway/monitor/monitor/monitorInfo/saveMonitorInfo', 'post', usersDataSave).then(res => {
  //   // res.isRequst = fasle 不让发送请求
  //   if (!res.data) {
  //     sessionStorage.setItem('isRequst', '')
  //     // 30S之后再改回原来状态
  //     let timer = setTimeout(() => {
  //       sessionStorage.setItem('isRequst', '1')
  //       clearTimeout(timer)
  //     }, 30000)
  //   }
  // })
}
export default monitor



// WEBPACK FOOTER //
// ./src/assets/js/monitor.js